import { SearchParams } from '@/types'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export interface ICreateTurfQualityPayload {
  name: string
  interfaceId: number
  irrigationFactor: number
}

export interface IUpdateTurfQualityPayload {
  id: number
  name: string
  interfaceId: number | string
  irrigationFactor: number
}

export interface IDeleteTurfQualityPayload {
  id: number | string
}

export interface ITurfQuality
  extends ICreateTurfQualityPayload,
    IDeleteTurfQualityPayload {
  interfaceId: number
  irrigationFactor: number
  calculatedWaterBudget: number
}

const turfQualityApi = {
  getAll(searchParams: SearchParams) {
    const url = '/api/TurfQuality'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(payload: IDeleteTurfQualityPayload): Promise<{ data: ITurfQuality }> {
    const { id } = payload
    const url = `/api/TurfQuality/${id}`
    return axiosClient.get(url)
  },

  create(payload: ICreateTurfQualityPayload) {
    const url = '/api/TurfQuality'
    return axiosClient.post(url, payload)
  },

  update(payload: IUpdateTurfQualityPayload) {
    // const { id, ...args } = payload
    const url = `/api/TurfQuality`
    return axiosClient.put(url, payload)
  },

  delete(
    payload: IDeleteTurfQualityPayload & { interfaceId: number | string },
  ) {
    const { id } = payload
    const url = `/api/TurfQuality`
    // return axiosClient.delete(url)
    return axiosClient.delete(url + queryStringify(payload))
  },
}

export default turfQualityApi
